<template>
    <div class="qksm">
        <div class="nogap">
            <h4>（二）2021年预算执行情况分析（截止2021年9月30日）</h4>
            <p>
                2021年{{$store.state.divData.divname}}（系统）预算支出{{isMoney(T2.总计)}}万元，为本年度预算{{calcRatio(T2.总计,T2.年初预算 + T2.年中追加)}}（详见附表二）。其中：
                <p v-for="(item,idx) in T2.支出" :key="idx">
                    {{idx + 1}}、{{item.name}}支出{{isMoney(item.value)}}万元，为本年度预算的{{isMoney(item.ratio*100)}}%{{idx + 1 == T2.支出.length ? '。' : '；'}}
                </p>
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        name: "qksm2Last",
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
        props: {
            T2: {
                type: Object,
                default: "",
            },
        },
    };
</script>